import React from "react";
import { useTranslation } from "react-i18next";
import LegalPage, { Section } from "./LegalPage";
import { ShieldCheck, Lock, Users2, Building2, Server, KeyRound } from "lucide-react";

const PILLAR_ICONS = {
  encryption: Lock,
  rbac: Users2,
  isolation: Building2,
  hosting: Server,
  authz: KeyRound,
  audit: ShieldCheck,
};

export default function Security() {
  const { t } = useTranslation("legal");
  const pillarKeys = ["encryption", "rbac", "isolation", "hosting", "authz", "audit"];
  return (
    <LegalPage title={t("security.title")} updated="24 July 2026">
      <p className="text-lg text-[#4B4642]">
        {t("security.intro")}
      </p>

      <div className="grid sm:grid-cols-2 gap-4 pt-2">
        {pillarKeys.map((k) => {
          const Icon = PILLAR_ICONS[k];
          return (
            <div key={k} className="rounded-2xl border border-[#EBE5D9] bg-white p-5">
              <div className="w-9 h-9 rounded-xl bg-[#FFEDE3] flex items-center justify-center text-[#E07A5F] mb-3">
                <Icon size={16} />
              </div>
              <div className="font-display font-semibold text-[#2C2A29] mb-1">
                {t(`security.pillars.${k}.title`)}
              </div>
              <div className="text-sm text-[#7A7571] leading-relaxed">
                {t(`security.pillars.${k}.body`)}
              </div>
            </div>
          );
        })}
      </div>

      <Section heading={t("security.disclosure.heading")}>
        <p>
          {t("security.disclosure.bodyPre")}
          <a href="mailto:security@orkaiflow.com" className="text-[#E07A5F] font-semibold hover:underline">security@orkaiflow.com</a>
          {t("security.disclosure.bodyPost")}
        </p>
      </Section>

      <Section heading={t("security.compliance.heading")}>
        <p>{t("security.compliance.body")}</p>
      </Section>

      <p className="text-xs text-[#7A7571] italic pt-4">
        {t("shell.starterDisclaimer")}
      </p>
    </LegalPage>
  );
}
